import { useNavigate } from "react-router-dom";
import Button from "../Button";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

interface CourseTagProps {
    nameCourse: string;
    level: string;
    titleFirst: string;
    titleSecond: string;
    titleThird: string;
    value: number;
    onExportExcel: (value: number) => void;
}

function CourseTag(props: CourseTagProps) {
    const { nameCourse, level, titleFirst, titleSecond, titleThird, value, onExportExcel } = props;
    const { user } = useSelector((state: RootState) => state.auth);
    const isStaff = user?.roles.includes("student_management") || user?.roles.includes("teacher") || user?.roles.includes("branch_manager") || user?.roles.includes("staff") || user?.roles.includes("teacher") || user?.roles.includes("admin") ;
    const router = useNavigate();

    const handleRegisterCourse = () => {
        router("/register");
    };

    const handleExportExcel = () => {
        onExportExcel(value);
    };

    return (
        <div className="max-w-sm mx-auto bg-white rounded-2xl shadow-md p-6 border-t-4 border-secondary flex flex-col items-start transition-transform duration-300 hover:-translate-y-2 hover:shadow-lg">
            <div className="flex flex-row items-center justify-between w-full">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">{nameCourse}</h2>
                {isStaff && (
                    <Button
                        label="Xuất Excel"
                        styleButton="bg-green-700 mb-4"
                        onClick={handleExportExcel}
                    />
                )}
            </div>
            <span className="inline-block bg-secondary text-white text-sm font-semibold py-[5px] px-[10px] rounded-full mb-4">
                {level}
            </span>
            <ul className="space-y-2 text-gray-700 mb-6">
                <li className="flex items-center">
                    <span className="text-success mr-2 font-bold">✓</span>
                    {titleFirst}
                </li>
                <li className="flex items-center">
                    <span className="text-success mr-2 font-bold">✓</span>
                    {titleSecond}
                </li>
                <li className="flex items-center">
                    <span className="text-success mr-2 font-bold">✓</span>
                    {titleThird}
                </li>
            </ul>
            <Button label="Đăng ký ngay" styleButton="bg-secondary w-full" onClick={() => handleRegisterCourse()} />
        </div>
    );
}

export default CourseTag;